import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { DatatableConfig } from 'src/app/config/DatatableConfig';
import { IReqBodyCopiar, IResBody, IResBusquedaCalendarizacion, IObjBusquedaCalendarizacion } from 'src/app/interfaces/calendarizacion';
import { IAnyos, IPeriodos } from 'src/app/interfaces/portal-calificaciones';
import { CalendarizacionService } from 'src/app/services/calendarizacion/calendarizacion.service';
import { PerfilamientoService } from 'src/app/services/perfilamiento/perfilamiento.service';
import { PortalCalificacionesService } from 'src/app/services/portal-calificaciones/portal-calificaciones';

@Component({
  selector: 'app-view-calendario-procesos-inicio',
  templateUrl: './view-calendario-procesos-inicio.component.html',
  styleUrls: ['./view-calendario-procesos-inicio.component.scss']
})
export class ViewCalendarioProcesosInicioComponent implements OnInit {
  dtOptions: DataTables.Settings | any = { ...DatatableConfig.dtOptionsWithPopOver }

  filtroAnyo: number = 0
  listaAnyo: Array<number> = []
  filtroPeriodo: number = 0
  listaPeriodo: any = []
  listaPeriodoOrigen: any = []
  listaPeriodoDestino: any = []

  filtrosCargados: any = {}
  tieneErrores: any = {}
  submitted: boolean = false

  listaCalendarizaciones: IResBusquedaCalendarizacion = []
  renderTable: boolean = false

  filtrosCargadosCopia: any = {}
  tieneErroresCopia: any = {}
  submittedCopia: boolean = false
  filtroAnyoCopiaOrigen: number = 0
  filtroPeriodoCopiaOrigen: number = 0
  filtroAnyoCopiaDestino: number = 0
  filtroPeriodoCopiaDestino: number = 0

  objCalendarizacionEliminar: IObjBusquedaCalendarizacion | any = {}
  calendarizacionEditada: boolean = false

  mensajeExito: string = ''
  mensajeError: string = ''
  errorCopia: string = ''

  alertaCreacion: string = ''

  parametrosForm = this.formBuilder.group({
    anyo: ['0', [Validators.required]],
    periodo: ['0', [Validators.required]],
  })

  constructor(
    private _calendarizacion: CalendarizacionService,
    private formBuilder: FormBuilder,
    private _portalServices: PortalCalificacionesService,
    private _perfilamiento: PerfilamientoService,
    private router: Router,
  ) {
    this.obtenerAnyos()

    const routerData = this.router.getCurrentNavigation()?.extras?.state?.['data']
    if ( routerData?.calendarizacionCreada ) {
      this.alertaCreacion = `Se ha creado con éxito el mantenedor de calendarización del proceso ${routerData?.nombreProceso}`
      setTimeout(() => {
        this.alertaCreacion = ''
      }, (3 * 1000))
    }
    if ( routerData?.calendarizacionEditada ) {
      this.calendarizacionEditada = true
      this.alertaCreacion = `Se ha modificado el mantenedor de calendarización del proceso ${routerData?.nombreProceso}`
      setTimeout(() => {
        this.alertaCreacion = ''
      }, (3 * 1000))
    }

    if (routerData?.filtros) {
      this.filtrosCargados = routerData.filtros
    }
  }

  ngOnInit(): void {
    this.dtOptions = { ...DatatableConfig.dtOptionsWithPopOver }
    setTimeout(() => {
      this.renderTable = true
    }, 500);
  }

  resetearValidacion(tipo: string = 'default'): void {
    this.submitted = false
    this.tieneErrores["anyo"] = false
    this.tieneErrores["periodo"] = false

    this.submittedCopia = false
    this.tieneErrores["anyoCopiaOrigen"] = false
    this.tieneErrores["anyoCopiaDestino"] = false
    this.tieneErrores["periodoCopiaOrigen"] = false
    this.tieneErrores["periodoCopiaDestino"] = false
  }

  limpiarFiltros(): void {
    this.filtroAnyo = 0
    this.filtroPeriodo = 0
    this.listaPeriodo = []
    this.submitted = false
    this.tieneErrores = []

    this.renderTable = false
    this.listaCalendarizaciones = []
    setTimeout(() => {
      this.renderTable = true
    }, 500)
  }

  cargarFiltros(filtro: string): void {
    if ( this.filtroAnyo === 0 && this.filtroPeriodo === 0 && this.filtroAnyoCopiaDestino === 0 && this.filtroAnyoCopiaOrigen === 0 ) {
      return
    }
    switch (filtro) {
      case "anyo":
        this.obtenerPeriodos(this.filtroAnyo)
        break;
      case "periodo":
        break;
      case "anyoCopiaOrigen":
        this.obtenerPeriodos(this.filtroAnyoCopiaOrigen, 'periodoCopiaOrigen')
        break;
      case "anyoCopiaDestino":
        this.obtenerPeriodos(this.filtroAnyoCopiaOrigen, 'periodoCopiaDestino')
        break;
      default:
        break;
    }
  }

  obtenerAnyos(): void {
    this._portalServices.obtenerListaAnhos().subscribe((res: IAnyos) => {
      this.listaAnyo = res.anyos
      if ( this.filtrosCargados?.anyo ) {
        this.filtroAnyo = this.filtrosCargados?.anyo
        delete this.filtrosCargados.anyo
      }
    })
  }

  obtenerPeriodos(filtroAnyo: number, tipo: string = ''): void {
    this.filtroPeriodo = 0

    if ( filtroAnyo !== 0 ) {
      this.tieneErrores["anyo"] = false
      this._portalServices.obtenerListaPeriodos(filtroAnyo).subscribe(
        (res: IPeriodos) => {
          if ( tipo === 'periodoCopiaOrigen' ) {
            this.listaPeriodoOrigen = res.periodos
          }
          if ( tipo === 'periodoCopiaDestino' ) {
            this.listaPeriodoDestino = res.periodos
          }
          if ( tipo === '' ) {
            this.listaPeriodo = res.periodos
          }
          if (this.filtrosCargados?.periodoId) {
            this.filtroPeriodo = this.filtrosCargados.periodoId
            delete this.filtrosCargados.periodoId
            this.buscarCalendarizacion()
          }
        }
      )
    }
  }

  buscarCalendarizacion(): void {
    this.submitted = true
    if ( this.filtroAnyo === 0 ) this.tieneErrores["anyo"] = true
    if ( this.filtroPeriodo === 0 ) this.tieneErrores["periodo"] = true
    const filtrosConErrores = Object.values(this.tieneErrores).filter(value => value === true)
    if ( filtrosConErrores.length > 0 ) {
      return
    }

    this.renderTable = false
    this._calendarizacion.getBusquedaCalendarizacion(this.filtroAnyo, this.filtroPeriodo).subscribe(
      (res: IResBusquedaCalendarizacion) => {
        this.listaCalendarizaciones = res
        this.renderTable = true
      }, () => {
        this.listaCalendarizaciones = []
        this.renderTable = true
      }
    )
  }

  limpiarMensajes(): void {
    setTimeout(() => {
      this.mensajeExito = ""
      this.errorCopia = ""
    }, 4 * 1000)
  }

  copiar(): void {
    this.submittedCopia = true
    if ( this.filtroAnyoCopiaOrigen === 0 ) this.tieneErrores["anyoCopiaOrigen"] = true
    if ( this.filtroAnyoCopiaDestino === 0 ) this.tieneErrores["anyoCopiaDestino"] = true
    if ( this.filtroPeriodoCopiaOrigen === 0 ) this.tieneErrores["periodoCopiaOrigen"] = true
    if ( this.filtroPeriodoCopiaDestino === 0 ) this.tieneErrores["periodoCopiaDestino"] = true
    const filtrosConErrores = Object.values(this.tieneErrores).filter(value => value === true)
    if ( filtrosConErrores.length > 0 ) {
      return
    }

    const body: IReqBodyCopiar = {
      anyoOrigen: this.filtroAnyoCopiaOrigen,
      periodoIdOrigen: this.filtroPeriodoCopiaOrigen,
      anyoDestino: this.filtroAnyoCopiaDestino,
      periodoIdDestino: this.filtroPeriodoCopiaDestino
    }
    this._calendarizacion.postCopiarCalendarizacion(body).subscribe(
      (res: IResBody) => {
        if ( res.error === null ) {
          this.mensajeExito = "Se ha realizado la copia correctamente."
          $("#btn-copiar").trigger("click")
        } else {
          this.errorCopia = res.error.mensaje
        }
        
        this.limpiarMensajes()
      }
    )
  }

  popupEliminar(calendario: IObjBusquedaCalendarizacion): void {
    if ( calendario.obligatorio ) return
    this.objCalendarizacionEliminar = {}

    document.getElementById('modal-eliminar-calendarizacion')?.click()
    this.objCalendarizacionEliminar = calendario
  }

  eliminar(): void {
    this._calendarizacion.eliminarCalendarizacion(this.objCalendarizacionEliminar.calendarizacionId).subscribe((res: IResBody) => {
      if ( res.error === null ) {
        this.mensajeExito = `Se ha eliminado el mantenedor del proceso ${this.objCalendarizacionEliminar.codigoProceso} correctamente.`
        document.getElementById('btn-modal-eliminar-dismiss')?.click()
      } else {
        this.mensajeError = res.error?.mensaje ?? 'Error en los servicios'
        document.getElementById('btn-modal-eliminar-dismiss')?.click()
      }
      this.limpiarMensajes()
      this.buscarCalendarizacion()
    })
  }

  editar(calendario: IObjBusquedaCalendarizacion): void {
    this.router.navigate(['/calendario-crear'], {
      state: {
        data: {
          editar: true,
          calendarizacion: calendario,
          filtros: {
            anyo: calendario.anyo,
            periodoId: calendario.periodoId,
            proceso: calendario.procesoId
          }
        }
      }
    })
  }

  navToCrearConfiguracion(): void {
    this.router.navigate(['/calendario-crear'])
  }

}
